<template>
  <div
    class="modal"
    :class="{ toggled: isToggled }"
    :style="{
      '--area-color': getLearningAreaSnipeColor(learningAreaName),
    }"
  >
    <div class="modal__box" @click="open">
      <Passes
        :passName="learningAreaName"
        :size="40"
        class="modal__area-icon"
      />
      <ConversationIcon class="modal__conversation-icon" />
    </div>
    <div class="modal__content">
      <p class="modal__heading">Have questions or comments?</p>
      <p class="modal__discussion">
        Join the discussion in our
        <a :href="`${communityBaseUrl}${communitySlug}/`" target="_blank">
          {{ learningAreaName }} Community.
        </a>
      </p>
      <div class="modal__close" @click="close" />
    </div>
  </div>
</template>

<script>
import { throttle } from 'lodash'
import CONSTANTS from '@/constants'
import Passes from '@/components/properties/Passes.vue'
import { getLearningAreaSnipeColor } from '@/helpers'
import ConversationIcon from '@/assets/icons/conversation_icon.svg'

export default {
  name: 'CommunityLinkModal',
  data: () => ({
    isToggled: false,
    scrollY: 0,
    communityBaseUrl: CONSTANTS.COMMUNITY_BASE_URL,
  }),
  components: {
    Passes,
    ConversationIcon: { ...ConversationIcon, name: 'ConversationIcon' },
  },
  props: {
    learningAreaName: {
      type: String,
      required: true,
    },
    communitySlug: {
      type: String,
      required: true,
    },
  },
  methods: {
    getLearningAreaSnipeColor,
    open() {
      if (!this.isToggled) {
        this.isToggled = true
        this.scrollY = window.scrollY
      }
    },
    close() {
      this.isToggled = false
    },
  },
  created() {
    this.handleScroll = throttle(() => {
      if (this.isToggled && Math.abs(this.scrollY - window.scrollY) > 150) {
        this.isToggled = false
      }
    }, 100)
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>

<style lang="scss" scoped>
.modal {
  z-index: 201;
  position: fixed;
  right: 24px;
  bottom: 14px;
  &__box {
    z-index: 2;
    position: absolute;
    right: 0;
    bottom: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    transition: transform 0.3s;
    will-change: transform;
    cursor: pointer;
    .modal.toggled & {
      transform: translateX(-345px);
      cursor: auto;
    }
  }
  &__conversation-icon {
    position: absolute;
    right: -10px;
    top: -5px;
    width: 18px;
    height: 18px;
    ::v-deep path {
      fill: var(--area-color, #fff);
      stroke: var(--area-color, #fff);
    }
  }
  &__content {
    z-index: -2;
    position: relative;
    width: 400px;
    height: 75px;
    padding: 20px 15px 0 70px;
    background-color: var(--dark-gray);
    background-image: linear-gradient(
      104.99deg,
      rgba(62, 63, 73, 0.7) -13.91%,
      rgba(62, 63, 73, 0) 100.48%
    );
    border-radius: 10px;
    opacity: 0;
    will-change: opacity;
    .modal.toggled & {
      z-index: 1;
      opacity: 1;
      transition: opacity 0.3s 0.1s;
    }
  }
  &__heading {
    margin-bottom: 2px;
    font-size: 16px;
    line-height: 23px;
    color: #fff;
  }
  &__discussion {
    font-size: 12px;
    line-height: 14px;
    color: var(--light-blue-gray);
    a {
      color: inherit;
      text-decoration: underline;
    }
  }
  &__close {
    position: absolute;
    right: 18px;
    top: 18px;
    width: 14px;
    height: 14px;
    opacity: 0.8;
    cursor: pointer;
    &:before,
    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -1px;
      width: 100%;
      height: 2px;
      background: #fff;
    }
    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  }
}
</style>
